import React from "react";
//redux
import { useSelector } from "react-redux";

import UserBasicInfo from "./../UserBasicInfo";
import UserFilters from "./../UserFilters";
import UserFinances from "./../UserFinances";
import UserSettings from "./../UserSettings.js";
import UserNotifications from "./../UserNotifications.js";
import UserHistory from "./../UserHistory.js";
import UserOffers from "./../UserOffers.js";
import UserReviews from "./../UserReviews.js";

import { Responsive, WidthProvider } from "react-grid-layout";
import useLocalStorage from "../../../hooks/useLocalStorage.js";
import { SELLER_DETAILS_LAYOUT_KEY, sellerDetailsLayout } from "../../../common/UserDetailsLayout";
import UserStatistics from "../UserStatistics";
import UserInquiry from "../UserInquiry";

const ResponsiveGridLayout = WidthProvider(Responsive);

export default function SellerDetails() {
    const user = useSelector((state) => state.userDetails.user);

    const [lsLayout, setLsLayout] = useLocalStorage(SELLER_DETAILS_LAYOUT_KEY, sellerDetailsLayout);

    return (
        <>
            {user && user.userid && (
                <ResponsiveGridLayout
                    className="layout"
                    cols={{ lg: 12, md: 12, sm: 12, xs: 12, xxs: 12 }}
                    rowHeight={30}
                    layouts={lsLayout}
                    isDraggable={false}
                    onLayoutChange={(layout, layouts) => {
                        setLsLayout(layouts);
                    }}
                >
                    <div key="1">
                        <UserBasicInfo />
                    </div>
                    <div key="2">
                        <UserNotifications />
                    </div>
                    <div key="3">
                        <UserHistory />
                    </div>
                    <div key="4">
                        <UserSettings />
                    </div>
                    <div key="5">
                        <UserFilters />
                    </div>
                    <div key="6">
                        <UserFinances />
                    </div>
                    <div key="7">
                        <UserOffers />
                    </div>
                    <div key="8">
                        <UserStatistics />
                    </div>
                    <div key="9">
                        <UserReviews />
                    </div>
                    <div key="10">
                        <UserInquiry />
                    </div>
                </ResponsiveGridLayout>
            )}
        </>
    );
}
